$(document).ready(() => {
    const $form = $('#developerLogin form');
    $form.on('submit', (e) => {
        e.preventDefault();
        $form.find(`input,textarea`).removeClass('is-invalid');
        $form.find('.invalid-feedback').html('');
        let data = {};
        $.each($(e.target).serializeArray(), (i, val) => {
            data[val.name] = val.value;
        });
        $.ajax({
            url: '/api_developers/register',
            type: 'post',
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: 'application/json'
        }).done((response) => {
            if (response.success) {
                $('#afterRegister').modal('show');
                $('#developerLogin').modal('hide');
            } else {
                $.each(response.errors, (field, msg) => {
                    let $field = $form.find(`[name=${field}]`);
                    $field.addClass('is-invalid');
                    $field.siblings('.invalid-feedback').html(msg);
                });
            }

        });
    });
});
